import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import {
  LayoutDashboard, Package, PlusCircle, Tag, Settings, FileText,
  LogOut, ShoppingBag, ChevronRight, Leaf, ExternalLink, Palette, Truck
} from 'lucide-react';
import './Sidebar.css';

const navItems = [
  { to: '/admin',          label: 'Dashboard',  icon: <LayoutDashboard size={18} />, end: true },
  { to: '/admin/orders',    label: 'Orders',     icon: <Truck size={18} /> },
  { to: '/admin/products', label: 'Products',   icon: <Package size={18} /> },
  { to: '/admin/add',      label: 'Add Product', icon: <PlusCircle size={18} /> },
  { to: '/admin/coupons',  label: 'Coupons',    icon: <Tag size={18} /> },
  { to: '/admin/blogs',    label: 'Blogs',      icon: <FileText size={18} /> }, 
  { to: '/admin/design',   label: 'Storefront', icon: <Palette size={18} /> },
  { to: '/admin/settings', label: 'Settings',   icon: <Settings size={18} /> },
];

export default function Sidebar({ collapsed, onToggle }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/admin/login');
  };

  return (
    <aside className={`admin-sidebar ${collapsed ? 'collapsed' : ''}`}>
      {/* Logo */}
      <div className="sidebar-logo" onClick={onToggle}>
        <div className="sidebar-logo-icon"><Leaf size={18} /></div>
        {!collapsed && (
          <div className="sidebar-logo-text">
            <span className="sidebar-brand">KOA</span>
            <span className="sidebar-admin-tag">Admin</span>
          </div>
        )}
        <button className="sidebar-toggle">
          <ChevronRight size={14} style={{ transform: collapsed ? 'none' : 'rotate(180deg)', transition: '0.3s' }} />
        </button>
      </div>

      {/* User */}
      {!collapsed && (
        <div className="sidebar-user">
          <div className="sidebar-avatar">{user?.username?.[0]?.toUpperCase()}</div>
          <div>
            <p className="sidebar-username">{user?.username}</p>
            <p className="sidebar-role">Administrator</p>
          </div>
        </div>
      )}

      {/* Nav */}
      <nav className="sidebar-nav">
        <p className="sidebar-nav-label">{!collapsed && 'MENU'}</p>
        {navItems.map(item => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.end}
            className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}
            title={collapsed ? item.label : ''}
          >
            <span className="sidebar-link-icon">{item.icon}</span>
            {!collapsed && <span className="sidebar-link-label">{item.label}</span>}
          </NavLink>
        ))}
      </nav>

      <div className="sidebar-bottom">
        <a
          href="/"
          target="_blank"
          rel="noreferrer"
          className="sidebar-link"
          title={collapsed ? 'View Store' : ''}
        >
          <span className="sidebar-link-icon"><ShoppingBag size={18} /></span>
          {!collapsed && <><span className="sidebar-link-label">View Store</span><ExternalLink size={12} style={{ marginLeft: 'auto', opacity: 0.4 }} /></>}
        </a>
        <button className="sidebar-link sidebar-logout" onClick={handleLogout} title={collapsed ? 'Logout' : ''}>
          <span className="sidebar-link-icon"><LogOut size={18} /></span>
          {!collapsed && <span className="sidebar-link-label">Logout</span>}
        </button>
      </div>
    </aside>
  );
}
